<!--  -->
<template>
  <div class=''>
    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>banner设置</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="bannerDialogVisible = true">添加</el-button>
          </div>
          <div class="block">
            <el-carousel trigger="click"
                         arrow="never"
                         height="360px">
              <el-carousel-item v-for="item in urls"
                                :key="item">
                <div>

                  <img :src="item" />
                  <a style="z-index: 10;position: absolute;top: 0;right: 0;padding: 5px;margin: 5px;font-size: 96%;color: #fff;background-color: rgb(0,0,0,0.3);"
                  @click="delBanner(item)">删除</a>
                </div>
              </el-carousel-item>
            </el-carousel>
            <!-- <h1 class="sliderText_">HUMAN AND GLOBAL NETWORK<br>
              TO LINK ENGINEERING<br>
              包装ライン技術でグローバルネットをつなぐ</h1> -->
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row type="flex"
            class="row-bg">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header"
               class="clearfix">
            <span>前言设置</span>
            <el-button style="float: right; padding: 3px 0"
                       type="text"
                       @click="forewordDialogVisible = true">编辑</el-button>
          </div>
          <div class="content html-wrap"
               v-html="oldHtmlContent">

          </div>

        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="添加banner"
               :visible.sync="bannerDialogVisible"
               width="980px">

      <el-form>
        <el-form-item label="图片地址"
                      label-width="180px">
          <el-input v-model="newUrl"
                    autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="bannerDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="addBanner">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="设置前言"
               :visible.sync="forewordDialogVisible"
               width="1070px">

      <editor api-key="haztyc1gdz9xbcxczo9mpis2ruh9dsjh3tupypkoj8b11zam"
              :init="editorConf"
              v-model="newHtmlContent"></editor>

      <span slot="footer"
            class="dialog-footer">
        <el-button @click="forewordDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="uploadHtmlContent">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
var Editor = require("@tinymce/tinymce-vue").default;
// import '../../assets/langs/zh_CN'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    editor: Editor // <- Important part
  },
  data() {
    //这里存放数据
    return {
      oldHtmlContent: "",
      newHtmlContent: "",
      newUrl:"",
      forewordDialogVisible: false,
      dialogImageUrl: "",
      dialogVisible: false,
      bannerDialogVisible: false,
      urls: [
        // "https://www.newlong.com/wp-content/themes/newlong/img/slide01.png",
        // "https://www.newlong.com/wp-content/themes/newlong/img/slide02.png",
        // "https://www.newlong.com/wp-content/themes/newlong/img/slide03.png"
      ]
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    delBanner(url){
      var that = this;
      this.$request.post({
        url: "/api/admin/cover/delBanner",
        params: { url: url },
        callback: {
          success: function(data) {
            if(data.code = -999){
              that.$store.commit('isLogin',false)
              return
            }
            that.$store.commit('isLogin',true)
            that.urls = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      }); 
    },
    addBanner(){
      var that = this;
      this.$request.post({
        url: "/api/admin/cover/addBanner",
        params: { url: that.newUrl },
        callback: {
          success: function(data) {
            that.newUrl = "";
            that.bannerDialogVisible = false;
            that.urls = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      }); 
    },
    uploadHtmlContent() {
      var that = this;
      this.$request.post({
        url: "/api/admin/cover/index_t",
        params: { html: that.newHtmlContent },
        callback: {
          success: function(data) {
            that.forewordDialogVisible = false;
            that.oldHtmlContent = data.data;
          },
          err: function(err) {
            console.log(err);
          }
        }
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    var that = this;
    this.$request.get({
      url: "/api/pageData/admin/home",
      // params: { a: "am" },
      callback: {
        success: function(data) {
          that.forewordDialogVisible = false;
          that.urls = data.data.banners;
          that.newHtmlContent = data.data.index;
          that.oldHtmlContent = that.newHtmlContent;
        },
        err: function(err) {
          console.log(err);
        }
      }
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style>
@import url("../../assets/css/all.css");

.home-contact .el-row {
  padding: 5px;
  text-align: right;
}

.home-contact .el-col-6 .el-input__inner {
  text-align: right;
}

.home-contact .el-col-18 {
  text-align: left;
}

.home-contact span {
  height: 40px;
  text-align: center;
  line-height: 40px;
}

.block {
  height: 360px;
  text-align: center;
  justify-content: center;
  /* display: flex; */
  position: relative;
  width: 100%;
}

.sliderText_ {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
  font-size: 230%;
  z-index: 2;
  color: #ffffff;
  text-shadow: 0px 0px 4px #737373;
}

.box-card {
  margin: 20px;
}

.box-card .el-card__body {
  padding: 0;
}
</style>